import React from 'react';
import classNames from 'classnames';
import { Icon } from 'tea-component';
import KnowledgeMentionIcon from '@/pages/aigc/assets/svg/skill-mention.svg';
import SkillSlashIcon from '@/pages/aigc/assets/svg/skill-slash-icon.svg';
import MentionCloseIcon from '@/pages/aigc/assets/svg/skill-close.svg';
import MentionCloseActiveIcon from '@/pages/aigc/assets/svg/agent-skill-del-active.svg';
import type { TMentionEditorKind } from './types';
import { KB_PREFILL_PLACEHOLDER_BODY } from '../utils/inlineMentionRanges';

export interface IMentionTokenProps {
  kind: TMentionEditorKind;
  body: string;
  mentionKey: string;
  /** skill 正文语种，用于 tag 后间距（中文 2px / 英文 4px） */
  script?: 'cjk' | 'latin';
  /** 历史展示等只读场景：不展示关闭按钮、不响应 hover 删除 */
  readOnly?: boolean;
}

const IDLE_ICON: Record<TMentionEditorKind, string> = {
  knowledge: KnowledgeMentionIcon,
  skill: SkillSlashIcon,
};

/** 输入框内联 mention tag（由 createMentionElement 渲染为 DOM 插入 contentEditable） */
const MentionToken: React.FC<IMentionTokenProps> = ({
  kind,
  body,
  mentionKey,
  script,
  readOnly = false,
}) => {
  const isLoading = body.trim() === KB_PREFILL_PLACEHOLDER_BODY;

  return (
    <span
      className={classNames(
        'dba-mention-token',
        `dba-mention-token--${kind}`,
        readOnly && 'dba-mention-token--readonly',
        isLoading && 'dba-mention-token--loading',
      )}
      contentEditable={false}
      data-mention-kind={kind}
      data-mention-body={body}
      data-mention-key={mentionKey}
      {...(kind === 'skill' && script ? { 'data-mention-script': script } : {})}
    >
      <span className="dba-mention-token__prefix">
        {isLoading ? (
          <span className="dba-mention-token__prefix-icon dba-mention-token__prefix-icon--loading">
            <Icon type="loading" />
          </span>
        ) : (
          <img
            src={IDLE_ICON[kind]}
            alt=""
            className={classNames(
              'dba-mention-token__prefix-icon',
              'dba-mention-token__prefix-icon--idle',
              `dba-mention-token__prefix-icon--${kind}`,
            )}
            draggable={false}
          />
        )}
        {!readOnly && !isLoading && (
          <span className="dba-mention-token__close" data-mention-action="remove">
            <img
              src={MentionCloseIcon}
              alt=""
              className="dba-mention-token__close-icon dba-mention-token__close-icon--idle"
              draggable={false}
            />
            <img
              src={MentionCloseActiveIcon}
              alt=""
              className="dba-mention-token__close-icon dba-mention-token__close-icon--active"
              draggable={false}
            />
          </span>
        )}
      </span>
      <span className="dba-mention-token__label">{body}</span>
    </span>
  );
};

export default MentionToken;
